import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ChartDataSets, ChartOptions, ChartType, RadialChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { Color, BaseChartDirective } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { single } from './data';
import { topevents } from './data';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { DashboardService } from '../services/dashboard.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  //options All Charts
  view: any[] = [700, 300];

  // options Number Chart
  multi;

  single: any[];
  colorScheme = {
    domain: ['#6F7EFF', '#6F7EFF', '#6F7EFF']
  };
  cardColor: string = '#232837';


  // options Line Chart
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = '';
  yAxisLabel: string = 'Number';
  timeline: boolean = true;

  colorSchemeLines = {
    domain: ['#2CD9C5', '#8C54FF',]
  };


  // options Bar Chart
  topevents: any[];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabelBar = true;
  xAxisLabelBar = '';
  showYAxisLabelBar = true;
  yAxisLabelBar = 'Views';

  colorSchemeBar = {
    domain: ['#F7D2FF']
  };

  dashboard1: any = [];
  dashboard2: any = [];
  dashboard3: any = [];
  dashboard4: any = [];

  visitorsMonth

  visitors

  range = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl()
  });

  filter: string = ""

  values: any = []
  valuesUser: any = []

  valuesMonth: any = []
  valuesMonthUser: any = []


  counter

  users

  keys



  constructor(private formBuilder: FormBuilder,
    private dashboardService: DashboardService,
  ) {
    Object.assign(this, { single });
    Object.assign(this, { topevents })
  }

  async ngOnInit() {
    await this.dashboardService.getVisitorsOverview('max')
      .then((res: any) => {
        this.displayVisitorsOverview(res);
      })
      .catch((error) => {

      })
      
    this.dashboardService.getDashboard().then((res: any) => {
      if (res.success) {
        console.log(res)
        this.dashboard4=res
        console.log("hi")
        console.log(this.dashboard4)
        
      }
    })
      .catch((error) => {
        console.log(error)
      })

    this.dashboardService.getMostViewedEvents().then((res: any) => {
      if (res.success) {
        this.dashboard3 = res.mostViewedEvents;
        this.dashboard3.sort((a, b) => parseFloat(b.hits) - parseFloat(a.hits));
        this.topevents = [
          {
            "name": this.dashboard3[0].event.event_name,
            "value": this.dashboard3[0].hits
          },
          {
            "name": this.dashboard3[1].event.event_name,
            "value": this.dashboard3[1].hits
          },
          {
            "name": this.dashboard3[2].event.event_name,
            "value": this.dashboard3[2].hits
          },
          {
            "name": this.dashboard3[3].event.event_name,
            "value": this.dashboard3[3].hits,
          },
          {
            "name": this.dashboard3[4].event.event_name,
            "value": this.dashboard3[4].hits
          }
        ]
      }
    })
      .catch((error) => {
        console.log(error)
      })
  }

  onSelect(data): void {
  }

  onActivate(data): void {
  }

  onDeactivate(data): void {
  }

  getDashboard1() {
    this.dashboardService.getDateOverview(this.range.value).then((res: any) => {
      if (res.success) {
        this.dashboard1 = res;
        this.single = [
          {
            "name": "Visits",
            "value": this.dashboard1.visitorsTotal
          },
          {
            "name": "Event Organizers",
            "value": this.dashboard1.organizersTotal
          },
          {
            "name": "Events",
            "value": this.dashboard1.eventsTotal
          },
        ];
      }
    })
      .catch((error) => {
        console.log(error)
      })
  }

  displayVisitorsOverview(data) {
        let visitores: any[] = data.visitors;
        let visitorsKeys = Object.keys(visitores);
        let visitorSeries: any[] = [];
        console.log(visitores)
        console.log("b",visitorsKeys)
        console.log("a",visitorSeries)
        //VISITORS CONCEPT
        for (let i = 0; i < visitorsKeys.length; i++) {
          let totalHits = 0;
          let key = visitorsKeys[i];
          let ips = visitores[key];
          let ipsKeys = Object.keys(ips)
          for (let j = 0; j < ipsKeys.length; j++) {
            let x = ips[ipsKeys[j]]
            totalHits += x[0].hits
          }
          visitorSeries.push(
            {
              "name": visitorsKeys[i],
              "value": totalHits
            })
        }
        //USERS CONCEPT
        let users: any[] = data.users;
        let usersKeys = Object.keys(users);
        let userSeries:any[] = [];
        for(let u=0;u<usersKeys.length;u++){
          let key= usersKeys[u];
          console.log(users[key][0].total)
          userSeries.push({
            "name": users[key][0].date,
            "value": users[key][0].total
          })
        }
        //FILLING THE ARRAY WITH DATA
        this.multi = [
          {
            "name": "Visitors",
            "series": visitorSeries
          },
          {
            "name": "Users",
            "series": userSeries
          }
        ];
  }

  submitDay() {
    this.filter = "day";
    this.displayVisitorsOverview(this.filter)
  }

  submitWeek() {
    this.filter = "week";
    this.displayVisitorsOverview(this.filter)
  }

  submitMonth() {
    this.filter = "month";
    this.displayVisitorsOverview(this.filter)
  }

  submitYear() {
    this.filter = "year";
    this.displayVisitorsOverview(this.filter)
  }

}